module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-en-US.9207fdb7.jpg";